import React from "react";
import bodyWaxingMythBanner from "./../../../../../Images/Blog/Body_waxing_myth/Banner.png";

const BodyWaxingMythImg = () => {
  return (
    <div className="blogImg-content">
      <img src={bodyWaxingMythBanner} alt="bodyWaxingMythBanner" loading="lazy" />
    </div>
  );
};

export default BodyWaxingMythImg;
